import React, { useState } from 'react';
import axios from 'axios';

const ReceiptUploadPanel = ({ bookingId }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [ocr, setOcr] = useState(null);
  const [receiptId, setReceiptId] = useState(null);
  const [matchMsg, setMatchMsg] = useState('');

  const upload = async () => {
    if (!file) return;
    setUploading(true);
    setMatchMsg('');

    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('booking_id', bookingId);

      const response = await axios.post('/receipt/upload', fd);
      
      setOcr(response.data.ocr);
      setReceiptId(response.data.receipt_id);
      setFile(null);
    } catch (err) {
      alert(err.response?.data?.detail || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const matchNow = async () => {
    if (!receiptId) return;
    setMatchMsg('Matching...');

    try {
      const response = await axios.post('/receipt/match', {
        booking_id: bookingId,
        receipt_id: receiptId
      });
      
      const data = response.data;
      const dollars = (c) => `$${(c / 100).toFixed(2)}`;
      setMatchMsg(
        `✅ Matched! Posted: ${dollars(data.booking_total_cents)} | Receipt: ${dollars(data.receipt_total_cents)} ${
          data.diff_cents !== undefined
            ? `(${data.diff_cents < 0 ? '-' : '+'}${dollars(Math.abs(data.diff_cents))})`
            : ''
        }`
      );
    } catch (err) {
      setMatchMsg(err.response?.data?.detail || 'Match failed');
    }
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-testid="receipt-upload-panel">
      <h4 className="font-semibold mb-3">Upload Grocery Receipt</h4>
      
      <div className="flex items-center gap-3 mb-3">
        <input
          type="file"
          accept="image/*,application/pdf"
          onChange={(e) => setFile(e.target.files[0])}
          className="text-sm"
          data-testid="receipt-file-input"
        />
        <button
          onClick={upload}
          disabled={uploading || !file}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 text-sm"
          data-testid="upload-receipt-button"
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </div>

      {ocr && (
        <div className="bg-white border border-gray-300 rounded-lg p-3 mb-3 text-sm" data-testid="ocr-preview">
          <div className="font-semibold mb-1">OCR Preview (Mocked)</div>
          <div>Merchant: {ocr.merchantName || '-'}</div>
          <div>Subtotal: {ocr.subtotalCents ? `$${(ocr.subtotalCents / 100).toFixed(2)}` : '-'}</div>
          <div>Tax: {ocr.taxCents ? `$${(ocr.taxCents / 100).toFixed(2)}` : '-'}</div>
          <div>Total: {ocr.totalCents ? `$${(ocr.totalCents / 100).toFixed(2)}` : '-'}</div>
        </div>
      )}

      <div>
        <button
          onClick={matchNow}
          disabled={!receiptId}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 text-sm"
          data-testid="match-receipt-button"
        >
          Match to Posted Transaction
        </button>
        {matchMsg && (
          <div className="mt-2 text-sm" data-testid="match-message">
            {matchMsg}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceiptUploadPanel;
